import axios from 'axios';

const BASE_URL = 'http://api.noasafe.com/api'
const BASE_URL_NEW = 'https://apiv2.noasafe.com/api'
const LOGIN_URL = 'http://api.noasafe.com/api'

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';  //此处是增加的代码，设置请求头的类型


// 登录请求方法
const loginreq = (method, url, params) => {
  return axios({
    method: method,
    url: LOGIN_URL + url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data);
};
const get = (url, params) => {
  return req('GET', url, params);
}

const post = (url, params) => {
  return req('POST', url, params);
}
// 通用公用方法
const req = (method, url, params) => {
  let user = window.window.sessionStorage.user;
  user = user && JSON.parse(user);
  return axios({
    method: method,
    url: BASE_URL + url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer ' + user.access_token
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data).catch(err => {

    console.log(err);
  })
};
// 通用公用方法
const reqnew = (method, url, params) => {
  let user = window.window.sessionStorage.user;
  user = user && JSON.parse(user);
  return axios({
    method: method,
    url: BASE_URL_NEW + url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data).catch(err => {

    console.log(err);
  })
};
// 通用公用方法
const reqFile = (method, url, params) => {
  let user = window.window.sessionStorage.user;
  user = user && JSON.parse(user);
  return axios({
    method: method,
    url: BASE_URL + url,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + user.access_token
    },
    data: params

  }).then(res => res.data).catch(err => {

    console.log(err);
  })
};



export {
  loginreq,
  get,
  post,
  reqFile,
  reqnew,
  req
}